import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { Title } from '../../styles';
import { HTMLtoJSX, removeTagsFromString } from '../../../../../../helpers';

const allowedTags = ['br', 's', 'em', 'u', 'strong', 'a', 'span'];

export const HeroModuleTitle = ({
  as: titleSize = 'h2',
  text,
  styled,
  colorType,
  style,
}) => {
  const { location } = useSelector(selectPageConfig);

  if (!text) {
    return null;
  }

  const as = titleSize.toLowerCase();
  const isStyled = as === 'h1' || styled;

  return (
    <Title
      as={as}
      className="formatted-text"
      isStyled={isStyled}
      colorType={colorType}
      style={style}
    >
      {HTMLtoJSX(removeTagsFromString(text, allowedTags), location)}
    </Title>
  );
};

HeroModuleTitle.propTypes = {
  text: PropTypes.string,
  h1: PropTypes.bool,
  styled: PropTypes.bool,
  colorType: PropTypes.string,
};
